import { Action } from '@ngrx/store';
import { ProductCountry } from '@app/models';

export enum ProductCountryActionTypes {
  LoadByProduct = '[ProductCountry] Load by product',
  LoadByProductSuccess = '[ProductCountry] Load by product Success',
  LoadByProductFail = '[ProductCountry] Load by product Fail',
  LoadByFollow = '[ProductCountry] Load by follow',
  LoadByFollowSuccess = '[ProductCountry] Load by follow Success',
  LoadByFollowFail = '[ProductCountry] Load by follow Fail',
  LoadByProductMirror = '[ProductCountryMirror] Load Product country mirror',
  LoadByProductMirrorSuccess = '[ProductCountryMirror] Load Product country mirror success',
  LoadByProductMirrorFail = '[ProductCountryMirror] Load Product country mirror fail',
  UpsertMany = '[ProductCountry] Upsert many',
  Update = '[API] Update ProductCountry',
  UpdateSuccess = '[API] Update ProductCountry success',
  UpdateFail = '[API] Update ProductCountry fail',
  UpdateOne = '[ProductCountry] Update one',
  UpdateMany = '[ProductCountry] Update many',
  BulkUpdate = '[API] Bulk update ProductCountry',
  BulkUpdateSuccess = '[API] Bulk update success ProductCountry',
  BulkUpdateFail = '[API] Bulk update fail ProductCountry',
  IterableUpdate = '[API] Iterable update,',
  Clear = '[Clear] Clear product country'
}

export class LoadByProduct implements Action {
  readonly type = ProductCountryActionTypes.LoadByProduct;
  constructor(public id: number) {}
}

export class LoadByProductSuccess implements Action {
  readonly type = ProductCountryActionTypes.LoadByProductSuccess;
  constructor(public countries: ProductCountry[]) {}
}

export class LoadByProductFail implements Action {
  readonly type = ProductCountryActionTypes.LoadByProductFail;
  constructor(public error: any) {}
}

export class Update implements Action {
  readonly type = ProductCountryActionTypes.Update;
  constructor(public id: number, public data: any, public ProductId?: number) {}
}

export class UpdateSuccess implements Action {
  readonly type = ProductCountryActionTypes.UpdateSuccess;
  constructor(public productCountry: ProductCountry) {}
}

export class UpdateFail implements Action {
  readonly type = ProductCountryActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class LoadByFollow implements Action {
  readonly type = ProductCountryActionTypes.LoadByFollow;
  constructor(
    public followId: number,
    public countryId?: number,
    public countryDepartmentId?: any,
    public CountryBuyerId?: number,
    public businessUnit?: any,
    public typeHierarchy?: any,
    public DestinationCenterId?: any,
    public component?: any
  ) {}
}

export class LoadByFollowSuccess implements Action {
  readonly type = ProductCountryActionTypes.LoadByFollowSuccess;
  constructor(public countries: ProductCountry[]) {}
}

export class LoadByFollowFail implements Action {
  readonly type = ProductCountryActionTypes.LoadByFollowFail;
  constructor(public error: any) {}
}

export class UpsertMany implements Action {
  readonly type = ProductCountryActionTypes.UpsertMany;
  constructor(public countries: ProductCountry[]) {}
}

export class UpdateOne implements Action {
  readonly type = ProductCountryActionTypes.UpdateOne;
  constructor(public productCountry: ProductCountry) {}
}

export class BulkUpdate implements Action {
  readonly type = ProductCountryActionTypes.BulkUpdate;
  constructor(
    public ProductIds: number[],
    public CountryId: number,
    public businessUnit: string,
    public data: any,
    public DestinationCenterId?: number
  ) {}
}

export class BulkUpdateSuccess implements Action {
  readonly type = ProductCountryActionTypes.BulkUpdateSuccess;
  constructor(public productCountries: ProductCountry[]) {}
}

export class BulkUpdateFail implements Action {
  readonly type = ProductCountryActionTypes.BulkUpdateFail;
  constructor(public error: any) {}
}

export class UpdateMany implements Action {
  readonly type = ProductCountryActionTypes.UpdateMany;
  constructor(public productCountries: ProductCountry[]) {}
}

export class IterableUpdate implements Action {
  readonly type = ProductCountryActionTypes.IterableUpdate;
  constructor(
    public ProductIds: number[],
    public dataProduct: any,
    public iterableData: any
  ) {}
}

export class LoadByProductMirror implements Action {
  readonly type = ProductCountryActionTypes.LoadByProductMirror;
  constructor(public ProductId: number) {}
}

export class LoadByProductMirrorSuccess implements Action {
  readonly type = ProductCountryActionTypes.LoadByProductMirrorSuccess;
  constructor(public countries: ProductCountry[]) {}
}

export class LoadByProductMirrorFail implements Action {
  readonly type = ProductCountryActionTypes.LoadByProductMirrorFail;
  constructor(public error: any) {}
}

export class Clear implements Action {
  readonly type = ProductCountryActionTypes.Clear;
  constructor() {}
}

export type ProductCountryActionsUnion =
  | LoadByProduct
  | LoadByProductSuccess
  | LoadByProductFail
  | Update
  | UpdateSuccess
  | UpdateFail
  | UpdateOne
  | UpdateMany
  | LoadByFollow
  | LoadByFollowSuccess
  | LoadByFollowFail
  | UpsertMany
  | BulkUpdate
  | BulkUpdateSuccess
  | BulkUpdateFail
  | IterableUpdate
  | LoadByProductMirror
  | LoadByProductMirrorSuccess
  | LoadByProductMirrorFail
  | Clear;
